import { ERROR_CODE as h } from "../../constants/error.js";
import { pageInfoSchema as l, thirdPartyPageInfoSchema as u } from "../../deserialize/yup/page.js";
import { CustomError as f } from "../../errors/customError.js";
import * as r from "ramda";
const y = (t) => r.isNil(t) || r.has("data", t) ? t : {
  data: t
}, p = (t) => {
  const a = t.data || {};
  return r.propOr("", "0", r.keys(a));
}, i = (t, a) => {
  const e = p(t);
  throw new f(
    `cannot deserialize "${e}" response, ${a.stack}`,
    h.GRAPHQL.CANNOT_DESERIALIZE
  );
}, c = (t, a = []) => {
  const e = y(t), n = p(e);
  return r.pathOr({}, ["data", n, ...a], e);
}, z = (t, a, e = []) => {
  const n = c(t, e);
  try {
    return l.validateSync({
      ...r.propOr({}, "pageInfo", n),
      page: a.page,
      pageSize: a.pageSize
    });
  } catch (o) {
    throw i(t, o);
  }
}, w = (t, a = []) => {
  const e = c(t, a);
  try {
    return u.validateSync({
      ...r.propOr({}, "paging", e)
    });
  } catch (n) {
    throw i(t, n);
  }
}, R = (t, a, e = void 0, n = []) => {
  const o = c(t, n);
  if (r.isEmpty(o))
    return null;
  try {
    return a.cast(o, { context: { data: o, extraData: e } });
  } catch (s) {
    throw i(t, s);
  }
}, S = (t, a, e = void 0, n = []) => {
  const o = c(t, n);
  if (r.isEmpty(o))
    return [];
  const s = r.is(Array, o) ? o : r.pipe(r.propOr([], "edges"), r.pluck("node"))(o);
  return r.map((d) => {
    try {
      return a.cast(d, {
        context: { data: d, extraData: e }
      });
    } catch (m) {
      throw i(t, m);
    }
  }, s);
};
export {
  R as deserializeData,
  S as deserializeListData,
  z as deserializePageInfo,
  c as deserializeResponse,
  w as deserializeThirdPartyPageInfo
};
//# sourceMappingURL=index.js.map
